import {capitalize} from 'lodash';
import React from 'react';
import {Headline} from '@lightricks/react-design-system';
import type {CampaignProps} from '@/types/campaign';
import BriefTag from './BriefTag';
import styles from './CampaignBriefHeader.module.scss';

interface CampaignBriefHeaderProps {
  campaign: CampaignProps;
  testID?: string;
}

function CampaignBriefHeader({
  campaign,
  testID = 'campaign-brief-header',
}: CampaignBriefHeaderProps) {
  const imageUrl = campaign.imageUrl ?? campaign.image;
  const specialtiesTags = campaign.preferredCreatorSpecialties ?? [];
  const capabilitiesTags = campaign.preferredCreatorCapabilities ?? [];
  const tags = [...specialtiesTags, ...capabilitiesTags].map((tag) => ({
    ...tag,
    name: capitalize(tag.name),
  }));

  return (
    <div className={styles.container} data-testid={testID}>
      {imageUrl ? (
        <img src={imageUrl} alt={campaign.name} className={styles.thumbnail} />
      ) : null}
      <div>
        <Headline size="xl" className={styles.name}>
          {campaign.name}
        </Headline>
        {tags.length > 0 ? (
          <div className={styles.tags}>
            {tags.map((tag) => (
              <BriefTag key={tag.id} label={tag.name ?? ''} />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default CampaignBriefHeader;
